exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-title[data-v-24fff686]{background-color:#1976d2;color:#fff;width:100%;height:100%}.clean-btn[data-v-24fff686]{color:#fff}", ""]);

// exports
